/**
 * @file Consumer Routes.
 */

import React from 'react';
import { Redirect } from 'react-router-dom';

import IdentitiesMasterView from '../views/Identities';
import SelfieSwapContainer from '../containers/selfie-swap/SelfieSwapContainer';
import ConsumerCustomPrintsMasterView from '../views/custom-prints/ConsumerCustomPrintsMasterView';
import CustomPrintAccountRedirectContainer from '../containers/custom-prints/CustomPrintAccountRedirectContainer';
import CustomPrintConfigurationView from '../views/custom-prints/CustomPrintConfigurationView';
import CustomPrintCheckoutView from '../views/custom-prints/CustomPrintCheckoutView';
import AlbumMembershipGroup from '../../temp/views/memberships/AlbumMembershipGroup';
import Checkout from '../../temp/views/memberships/Checkout';
import MembershipsMasterView from '../../temp/views/memberships/MembershipsMasterView';
import TagSelection from '../../temp/views/onboarding/TagSelection';
import WaldogramReferralPlaceholder from '../components/WaldogramReferralPlaceholder';
import PhotoSearchUpgradeCheckout from '../../temp/views/onboarding/PhotoSearchUpgradeCheckout';
import MatchedPhotos from '../../temp/views/memberships/AlbumMembershipGroup/components/MatchedPhotos';
import AllPhotos from '../../temp/views/memberships/AlbumMembershipGroup/components/AllPhotos';

const routes = [
  {
    path: '/consumer/identities',
    exact: false,
    component: IdentitiesMasterView,
    routes: [
      {
        path: '/consumer/identities',
        exact: true,
        component: SelfieSwapContainer,
      },
    ],
  },
  {
    path: '/consumer/matches',
    exact: false,
    component: MembershipsMasterView,
    routes: [
      {
        // This path contains the `albumMembershipGroupId` because there's
        // nowhere else to go now but if/when we implement an eagle eye view of
        // all galleries/albums it will probably need to move to /matches/checkout.
        path: '/consumer/matches/:albumMembershipGroupId/checkout',
        exact: true,
        component: Checkout,
      },
      {
        path: '/consumer/matches/:albumMembershipGroupId',
        exact: false,
        component: AlbumMembershipGroup,
        routes: [
          {
            path: '/consumer/matches/:albumMembershipGroupId/all',
            exact: false,
            component: AllPhotos,
          },
          {
            path: '/consumer/matches/:albumMembershipGroupId',
            exact: false,
            component: MatchedPhotos,
          },
        ],
      },
    ],
  },
  {
    // This path is decoupled (as a route) from the rest of the consumer app
    // as it needs to function stand-alone, i.e. a Waldo Admin texts
    // this URL to a user and the user is called to fill in their tag information.
    path: '/consumer/tags/:albumFolderId',
    exact: true,
    component: TagSelection,
  },
  {
    path: '/consumer/tags/:albumFolderId/:targetIdentityId',
    exact: true,
    component: TagSelection,
  },
  {
    path: '/consumer/custom-prints',
    exact: false,
    component: ConsumerCustomPrintsMasterView,
    routes: [
      {
        path: '/consumer/custom-prints/redirect',
        exact: true,
        component: CustomPrintAccountRedirectContainer,
      },
      {
        path: '/consumer/custom-prints/:purchasedCustomPrintId',
        exact: true,
        component: CustomPrintConfigurationView,
      },
      {
        path: '/consumer/custom-prints/checkout/:albumId',
        exact: true,
        component: CustomPrintCheckoutView,
      },
    ],
  },
  {
    path: '/consumer/photo-search-checkout',
    exact: true,
    component: PhotoSearchUpgradeCheckout,
  },
  {
    path: '/consumer/card',
    exact: true,
    component: WaldogramReferralPlaceholder,
  },

  // Temporary until we create a hub for consumers.
  {
    path: '/consumer',
    exact: true,
    component: () => <Redirect to="/consumer/identities" />,
  },
];

export default routes;
